<template>
  <div id="demo-basic-card">

    <div id="addModuleLoadingDiv" class="vs-con-loading__container">
        <vx-card  class="mb-base">
            <template   slot="actions">
                <vx-tooltip text="Back to all categories" position="left">
                    <feather-icon @click="redirectToAllCategories()" icon="ChevronsLeftIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
                </vx-tooltip>
            </template>
            
            
            <p>List deleted successfully. </p>

            <br><br>

            <a style="cursor: pointer;" @click="redirectToAllCategories()" >Go back</a>

        </vx-card>
    </div>

  </div>
</template>


<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleLearningHub from '@/store/learninghub/moduleLearningHub.js'
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import vSelect from 'vue-select'
import Treeselect from '@riophae/vue-treeselect'
  // import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import axios from "@/axios.js"

export default{
    data() {
        return {
            
        }
    },
    components: {
        VuePerfectScrollbar,
        swiper,
        swiperSlide,
        vSelect,
        Treeselect,
    },
    computed: {
    },
    methods: {
        redirectToAllCategories() {
            this.$router.push("/learninghublisting").catch(() => {})
        },
    },
    created() {

        axios.post("/api/learninghub/delete", {
            id: this.$route.params.id
        })
        .then((response) => {
            this.$vs.notify({
                    time:4000,
                    title:'Success',
                    text: (res.data.status) ? res.data.status : 'List has been deleted successfully.',
                    color:'success',
                    iconPack: 'feather',
                    icon:'icon-alert-circle'
                });
        })
        .catch((error) => { reject(error) })
            
    },

}
</script>

